// extracted by mini-css-extract-plugin
module.exports = {"figure":"style_figure__zYoKw","caption":"style_caption__j5O_M g-type-body-small"};